import { useCurrentUserStore } from "@/stores/currentUser";
import { storeToRefs } from "pinia";
import { computed } from "vue";
export const useUser = () => {
  const currentUserStore = useCurrentUserStore();

  const getInitials = computed(() => {
    const { getUser: user } = storeToRefs(currentUserStore);
    if (!user.value) return "JD";
    const firstName = user.value.first_name;
    const lastName = user.value.last_name;
    return firstName && lastName ? `${firstName[0]}${lastName[0]}` : false;
  });

  return {
    getInitials,
  };
};
